import React from 'react';
import { Link } from 'react-router-dom';
import { formatFullName} from "../../utils/personUtils";
import { UserIcon } from "lucide-react";
import { API_URL } from "../../services/apiService";
import { useTranslation } from "react-i18next";

const ResultsList = ({ results, query }) => {
    const {t, i18n} = useTranslation();

    if (!results || results.length === 0) {
        return (
            <div className="bg-white rounded-lg shadow-sm border border-[#e6dfd4] p-8 text-center">
                <h2 className="text-xl font-medium text-[#4a3f30] mb-2">
                    {t('resultsPage.noResults')} "{query}"
                </h2>
                <p className="text-[#937c5d]">{t('resultsPage.tryDifferent')}</p>
            </div>
        );
    }

    // פונקצית המיון המעודכנת
    const compareNames = (a, b) => {
        // תמיד נשתמש ב-formatFullName עם פרמטר true כדי לקבל שם משפחה לפני שם פרטי
        const nameA = formatFullName(a, i18n.language, true) || '';
        const nameB = formatFullName(b, i18n.language, true) || '';

        // מיון לפי השפה הנוכחית
        return nameA.localeCompare(nameB, i18n.language, {
            sensitivity: 'base',  // התעלמות מאותיות גדולות/קטנות
            numeric: true        // מיון נכון של מספרים
        });
    };

    // מיון התוצאות - תמיד נציג שם משפחה ואז שם פרטי
    const sortedResults = [...results].sort(compareNames);

    return (
        <div className="space-y-4">
            {sortedResults.map((person) => (
                <Link
                    key={person.gedId}
                    to={person.path}
                    className="block bg-white rounded-lg shadow-sm border border-[#e6dfd4] hover:shadow-md transition-shadow duration-200"
                >
                    <div className="p-6">
                        <div className="flex items-start gap-4">
                            <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-[#e6dfd4]">
                                {person.images?.length > 0 ? (
                                    <img
                                        crossOrigin="use-credentials"
                                        src={`${API_URL}/image/download/${encodeURIComponent(person.images[0])}`}
                                        alt={formatFullName(person, i18n.language, true)}
                                        className="w-full h-full rounded-lg object-cover"
                                    />
                                ) : (
                                    <UserIcon className="w-6 h-6 text-[#937c5d]"/>
                                )}
                            </div>
                            <div className="flex items-start justify-between">
                                <div>
                                    <h3 className="text-xl font-medium text-[#4a3f30] mb-2 flex items-center">
                                        {formatFullName(person, i18n.language, true)}
                                        {person.isDifferentFamilyTree && (
                                            <span className="text-[10px] sm:text-xs bg-red-50 text-red-500
                                            px-1.5 sm:px-2 py-0.5 rounded-full
                                            border border-red-100 font-medium
                                            whitespace-nowrap">
                                                {t('searchResults.otherFamilyTree')}
                                            </span>
                                        )}
                                    </h3>
                                    {person.connections && person.connections.length > 0 && (
                                        <p className="text-[#937c5d] text-sm">
                                            {t('resultsPage.connections')} {person.connections.length}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>
            ))}
        </div>
    );
};

export default ResultsList;